export default __webpack_public_path__ + "static/media/gallery17.64f79a4e.jpg";